import axios from "axios";

const instance = axios.create({
  baseURL: "https://budiman.io/api/",
});

export default instance;
